<template>
  <div :class="{ newWrap: canCancelSubscription }">
    <div class="item-title">
      <div class="split" />
      金融权益如何使用
    </div>
    <div class="item-content">
      <p>1·仅限极融、你我货平台借款时使用</p>
      <p>
        2.使用日期：自领取之日起30天内有效（有效起止日期与权益有效日期一致）
        。需要在有效期内使用完毕，逾期失效，不支持补发。
      </p>
      <p>
        3.使用限制：单笔借款单次仅限使用一张；单笔放款勾选即使用，如未勾选可至券列表页查询。
      </p>
    </div>

    <div class="item-title">
      <div class="split" />
      生活权益如何使用
    </div>
    <div class="item-content">
      <p>1.仅限购买该权益时使用</p>
      <p>
        2.使用日期：自领取之日起30天内有效。优惠券需要在有效期内使用完毕，逾期失效，不支持补发。
      </p>
      <p>
        3.使用限制：此电子券为一次性使用产品，不与折扣、促销活动、其他优惠券等同享，不可拆分使用，不找零。
      </p>
      <p>4.退款规则：权益类商品购买后不退不换。</p>
      <p>5.特别说明：</p>
      <p>
        部分餐厅法定节假日及特殊日期不能适用，优惠券适用范围以实际页面为准。
      </p>
      <p>
        部分酒店法定节假日及特殊日期不能适用，具体情况以对应酒店规则与实际兑换页面为准。（不同酒店对预订时间要求提前1—3天不等，需在可订时间内方可提交预订）
      </p>
      <p>6.以上商品展示为全部商品，具体以实际为准。</p>
      <p>7.如有疑问请咨客服，客服电话：400-150-9669（7:00-21:00）</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: ["canCancelSubscription"],
  setup() {},
});
</script>


<style scoped lang="less">
.newWrap {
  .item-content {
    background: rgba(245, 229, 206, 0.25);
  }
}

.item-title {
  display: flex;
  align-items: center;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  margin-top: 24px;

  .split {
    width: 2px;
    height: 14px;
    background: #e4d1b4;
    border-radius: 1px;
    margin-right: 4px;
  }
}

.item-content {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 12px;
  margin-top: 12px;

  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 23px;
}
</style>